export default "__VITE_ASSET__BBQDYXe5__"